<template>
  <div class="section content">
    <div
      v-if="readOnly"
      class="columns"
    >
      <div class="column">
        <div class="message">
          <div class="message-body">
            <p>This section is disabled. Changes must be done by a system administrator.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-centered">
        <h2 class="title is-2">
          System Access
        </h2>
        <div class="subtitle is-2">
          Select one or more roles for this user.
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-one-third has-text-centered">
        <radio-adv
          id="system-access-type-sys-admin"
          v-model="checkedRoles.adminRole"
          value="sysAdmin"
          :disabled="readOnly || requester === 'deptHead'"
        >
          System Admin
        </radio-adv>
      </div>
      <div class="column is-one-third has-text-centered">
        <radio-adv
          id="sytem-access-type-dept-head"
          v-model="checkedRoles.adminRole"
          value="deptHead"
          :disabled="readOnly"
        >
          Department Admin
        </radio-adv>
      </div>
      <div class="column is-one-third has-text-centered">
        <checkbox-adv
          id="sytem-access-type-filer"
          v-model="checkedRoles.filer"
          value="Y"
          :disabled="readOnly"
        >
          Filer
        </checkbox-adv>
      </div>
      <div class="column is-full has-text-centered">
        <div v-if="!readOnly">
          <a
            href="#"
            @click.prevent="removeAdminRoles"
          >
            Remove all admin roles
          </a>
        </div>
      </div>
    </div>
    <div class="validate-tooltip columns v-center-bottom v-arrow-center-top">
      <transition name="fade">
        <span
          v-if="!readOnly && !hasRoles"
          class="column shrink error popover"
          v-text="'An user must have at least one role.'"
        />
      </transition>
    </div>
  </div>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import CheckboxAdv from '@/components/phila-ui/CheckboxAdv';
import RadioAdv from '@/components/phila-ui/RadioAdv';

export default {
  name: 'UserSystemAccess',
  components: {
    CheckboxAdv,
    RadioAdv,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  props: {
    type: {
      type: String,
      default: 'user',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    requester: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hasRoles: true,
      profile: {
        sysAdmin: 'N',
        deptHead: 'N',
        filer: 'N',
      },
      checkedRoles: {
        adminRole: '',
        filer: '',
      },
      systemAccessReady: false,
    };
  },
  watch: {
    checkedRoles: {
      async handler (value) {
        let roleObj = {
          sysAdmin: 'N',
          deptHead: 'N',
          filer: 'N',
        };
        if (value.adminRole === 'sysAdmin') {
          roleObj.sysAdmin = 'Y';
        }
        if (value.adminRole === 'deptHead') {
          roleObj.deptHead = 'Y';
        }
        if (value.filer === 'Y') {
          roleObj.filer = 'Y';
        }

        let hasOneOrMoreRoles = Object.keys(roleObj).some(role => {
          if (roleObj[role] === 'Y') {
            return true;
          }
          return false;
        });

        this.hasRoles = hasOneOrMoreRoles;
        this.$emit('systemAccessRoles', roleObj);
        this.$emit('systemAccessHasRoles', hasOneOrMoreRoles);
      },
      deep: true,
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$emit('systemAccessRolesReady', true);
  },
  methods: {
    async initialAssign () {
      if (this.type === 'user') {
        this.profile = await this.getUserProfile();
      } else if (this.type === 'tempUser') {
        this.profile = await this.getTempUserProfile();
      }

      if (this.profile.sysAdmin === 'Y') {
        this.checkedRoles.adminRole = 'sysAdmin';
      } else if (this.profile.deptHead === 'Y') {
        this.checkedRoles.adminRole = 'deptHead';
      }

      if (this.profile.filer === 'Y') {
        this.checkedRoles.filer = 'Y';
      }
      // this.roles = {
      //   sysAdmin: {
      //     label: 'System Administrator',
      //     key: 'sysAdmin',
      //   },
      //   deptHead: {
      //     label: 'Department Administrator',
      //     key: 'deptHead',
      //   },
      //   filer: {
      //     label: 'Filer',
      //     key: 'filer',
      //   },
      // };
    },
    async initialFetch () {
      let promises = [];
      if (this.type === 'user') {
        // promises.push(this.$store.dispatch('user/fetchUserProfile'));
      } else if (this.type === 'tempUser') {
        promises.push(this.$store.dispatch('user/fetchUserProfile', this.$store.state.user.tempId));
      }
      await Promise.all(promises);
    },
    removeAdminRoles () {
      this.checkedRoles.adminRole = '';
    },
    getUserProfile () {
      return this.cloneObj(this.$store.state.user.profile);
    },
    getTempUserProfile () {
      return this.cloneObj(this.$store.state.user.tempProfile);
    },
  },
};
</script>
